<template>
  <div>

    <Scanner />
    <LineMatrix />
    <IDPrinter />

  </div>
</template>

<script>
import Scanner from './it-solutions-hardware/Scanner.vue';
import LineMatrix from './it-solutions-hardware/LineMatrix.vue';
import IDPrinter from './it-solutions-hardware/IDPrinter';



export default {
  components: {
    Scanner,
    LineMatrix,
    IDPrinter
  },
};
</script>

<style scoped></style>
